/**
 * How It Works section showing a 3-step enrollment process.
 *
 * Renders numbered steps in a responsive grid — horizontal on desktop,
 * vertical stack on mobile. Each step displays a numbered circle, title,
 * and description. Data-driven via the {@link HOW_IT_WORKS_STEPS} array.
 *
 * @module landing/sections/HowItWorksSection
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResponsiveContainer } from '../../../shared/src/responsive/ResponsiveContainer';
import { ResponsiveGrid } from '../../../shared/src/responsive/ResponsiveGrid';
import { SectionHeading } from '../components/SectionHeading';
import { HOW_IT_WORKS_STEPS } from '../content/how-it-works';

/**
 * How It Works section with numbered step indicators.
 */
export function HowItWorksSection(): React.JSX.Element {
  const { t } = useTranslation('landing');

  return (
    <ResponsiveContainer>
      <SectionHeading
        title={t('howItWorks.heading')}
        subtitle={t('howItWorks.subheading')}
      />
      <ResponsiveGrid lg={3}>
        {HOW_IT_WORKS_STEPS.map((item) => (
          <div key={item.step} className="landing-step">
            <div className="landing-step__number" aria-hidden="true">
              {item.step}
            </div>
            <h3 className="landing-step__title">
              {t(`howItWorks.${item.i18nKey}.title`)}
            </h3>
            <p className="landing-step__description">
              {t(`howItWorks.${item.i18nKey}.description`)}
            </p>
          </div>
        ))}
      </ResponsiveGrid>
    </ResponsiveContainer>
  );
}
